export function orgRoleToNorwegian(role: string | null | undefined): string {
	switch (role) {
		case 'owner':
		case 'org:owner':
			return 'Eier';
		case 'admin':
		case 'org:admin':
			return 'Administrator';
		case 'employee':
		case 'org:employee':
			return 'Ansatt';
		default:
			return 'Ukjent';
	}
}

export function formatReadingTime(time: number) {
	if (time < 1) {
		return '1 min';
	}
	return `${Math.ceil(time)} min`;
}

/** A property's display name is always its address - never a user-assigned name. */
export function formatPropertyDisplayName(property: {
	address?: string | null;
	postnumber?: string | null;
	city?: string | null;
}): string {
	const addressLine = property.address ?? '';
	const cityLine = [property.postnumber, property.city].filter(Boolean).join(' ');
	return [addressLine, cityLine].filter(Boolean).join(', ');
}

export function formatDate(date: Date) {
	const now = new Date().getTime();
	const age = now - date.getTime();

	if (age < 24 * 60 * 60 * 1000) {
		return date.toLocaleTimeString('no-NO', {
			hour: '2-digit',
			minute: '2-digit'
		});
	}
	if (age < 7 * 24 * 60 * 60 * 1000) {
		return date.toLocaleDateString('no-NO', {
			weekday: 'long'
		});
	}
	return date.toLocaleDateString('no-NO', {
		year: 'numeric',
		month: 'long',
		day: 'numeric'
	});
}
